<!--产品介绍-->
<template>
  <div class="pi">
    <!-- <a href="#" class="preleft"><img src="@/assets/images/pre_left.png"></a> -->
    <!-- <a href="#" class="preright"><img src="@/assets/images/pre_right.png"></a> -->

    <!-- <div class="imgbox">
      <div class="lilist">
        <li v-for="(item,index) in piData" :key="index" @click="PIclick(item.id)">
          <div class="img">
            <img :src="item.src">
          </div>
          <div class="text">{{item.name}}</div>
        </li>
      </div>
    </div> -->
 
      <vue-seamless-scroll  ref="seamlessScroll" class="warp"  :data="piData" :class-option="{limitMoveNum: 5,direction: 2,step:0.8}">

        <ul  class=" ul-item">
          <li :productdata-index='index'  class="li-item" v-for="(item,index) in piData" :key="index">
            <div class="img">
              <img :src="item.pimg">
            </div>
            <div class="text">{{item.pname}}</div>
          </li>
        </ul>

      </vue-seamless-scroll>



    <el-dialog v-dialogDrag :visible.sync="PIdialog" width="50%" title="产品详情">
      <div class="product">
        <img :src="productValue.pimg">
        <div class="right">
          <!-- <el-tabs v-model="activeName" >
            <el-tab-pane :label="productValue.pname" name="first">
              <div v-html="productValue.content"></div>
            </el-tab-pane>
            <el-tab-pane label="产品特点" name="second">产品特点</el-tab-pane>
            <el-tab-pane label="项目案例" name="third">项目案例</el-tab-pane>
          </el-tabs> -->
          <div class="title">{{productValue.pname}} </div>
          <div v-html="productValue.content"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="PInext">下一款产品</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import api from '@/apis/CompanyProfile'
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {

      piData: [
        // {
        //   id: 0,
        //   pname: '电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 1,
        //   pname: '111电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic3.png'),
        // },
        // {
        //   id: 2,
        //   pname: '22电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 3,
        //   pname: '33电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic3.png'),
        // },
        // {
        //   id: 4,
        //   pname: '44电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 5,
        //   pname: '55电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 6,
        //   pname: '66电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic3.png'),
        // },
        // {
        //   id: 7,
        //   pname: '77电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
      ],
      productId:0,
      productValue:{
        pimg:require('@/assets/images/pic2.png'),
        pname:'',
        content:'',
      },
      PIdialog: false,
      activeName: 'first',
      
    }
  },
  methods: {
    PIclick(id) {
      this.productId = id
      this.PIdialog = true
      this.productValue = this.piData[id]
    },
    PInext(){
      this.productId++
      if ( this.productId>=this.piData.length) {
        this.productId = 0
      }
      this.productValue = this.piData[ this.productId]
    },
  },
  mounted() {
      api
        .product({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {


            this.piData = res.data.list
            this.$refs.seamlessScroll.reset()

            this.$nextTick(() => {
              setTimeout(() => {
                let element = document.querySelectorAll('[productdata-index]')
                for (const iterator of element) {
                  iterator.onclick = () => {
                    //绑定事件
                    let index = iterator.getAttribute('productdata-index')
                    this.PIclick(index)
                  }
                }
              }, 1000)
            })

          } else {
            this.$message.error(res.message)
          }
        })


  },
}
</script>

<style lang="less" scoped>
.pi {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0.71rem;
  overflow: hidden;
  .preleft,
  .preright {
    position: absolute;
    top: 35%;
    width: 1.9rem;
    left: 10px;
    img {
      width: 100%;
    }
  }
  .preright {
    left: auto;
    right: 10px;
  }

  .warp {
    width: 100%;
    height: 100%;
    overflow: hidden;
    & > div {
      height: 100%;
    }
    .ul-item {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      height: 100%;
      display: flex;
      .li-item {
        cursor: pointer;
        width: 12rem;
        height: 100%;
        margin-right: 0.6rem;
        background-color: #999;
        color: #fff;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: 30px;
        .img {
          flex: 1;
          overflow: hidden;
          width: 100%;
          // border: #3570ff solid 0.15rem;
           position: relative;
          img {
            min-width: 100%;
            height: 100%;
          }
        }
        .text {
          width: 100%;
          text-align: center;
          height: 1.3rem;
          line-height: 1.3rem;
          font-size: 0.68rem;
          background: #01123a;
          color: #fff;
          padding: 0px 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }

  .product {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    img {
      width: 19rem;
      height: 16rem;
      margin-right: 1rem;
    }
    .right {
      flex: 1;
      overflow: hidden;
      .title{ font-size: .8rem; color: #00ccff; border-bottom: #00ccff solid 1px; margin-bottom: .6rem; line-height: 1.8rem;}
    }
  }
}
</style>
<style lang='less'>
.warp {
  & > div {
    height: 100%;
    & > div {
      height: 100%;
    }
  }
}
</style>